"use client";

import React from "react";

function AffiliateSectionLink({ name, book, retailer, affiliateButtonStyles }) {
  //eventLabel & eventAction declared here and inserted as data-vars to have event tracking
  let eventLabel = `${book.title} | ${book.primary_isbn} | ${book.publisher}`,
    eventAction = "Retail Click";

  const trackAffiliateClick = (retailerName, book) => {
    const action = "Retail Click, ";
    const payload = {
      eventCategory: "Ebook",
      eventAction: `${action}${retailerName}`,
      eventLabel: `${book.title} | ${book.primary_isbn} | ${book.publisher}`,
    };
    if (typeof window != "undefined") {
      //window.ga('orim180.send', 'event', payload);
      //Converting it to Datalayer push instead of GA Event as part of https://openroadmedia.atlassian.net/browse/ORMTECH-796
      window.dataLayer.push({ event: action, ...payload });
    }
  };
  return (
    <a
      className={`mx-auto ${affiliateButtonStyles}`}
      rel="nofollow noopener noreferrer"
      target="_blank"
      onClick={() => trackAffiliateClick(name, book)}
      href={retailer.url}
      data-vars-event-label={eventLabel}
      data-vars-event-action={eventAction}
      data-vars-outbound-url={retailer.url}
      data-vars-outbound-text={name}
      id={`retailerbutton-${name}`}
    >
      {name}
    </a>
  );
}

export default AffiliateSectionLink;
